import React from 'react';
import cx from 'classnames';
import { find } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { formatPrice } from 'utilities/money';

import { PricingComponent, SubscriptionPlan } from '@payments/types';
import * as utils from '@payments/utils';

import style from './style.module.scss';

interface Props {
  isCalculatingPricing: boolean;
  isInstallments: boolean;
  pricingComponents: PricingComponent[];
  subscriptionPlan: SubscriptionPlan;
}

const Confirmation: React.FC<Props> = (props) => {
  const lsacComponent = find(props.pricingComponents, (component) => component.type === 'lsac');
  const savingsComponent = find(props.pricingComponents, (component) => component.type === 'savings');
  const subscriptionComponent = find(props.pricingComponents, (component) => component.type === 'subscription');
  const taxComponent = find(props.pricingComponents, (component) => component.type === 'tax');

  const listPrice = subscriptionComponent.priceInCents + (lsacComponent?.priceInCents || 0);
  const totalPrice = props.pricingComponents.reduce((sum, component) => (sum + component.priceInCents), 0);

  return (
    <div>
      <div className="u-margin-B-s">
        <h4 className="u-margin-V-n inline-form-right">
          <strong>{props.subscriptionPlan.name}</strong>
        </h4>
        <p className="inline-form-right-help extra-bottom-margin">
          <small className="text-gray-light">
            Expires on {utils.calculateExpirationDate(props.subscriptionPlan.durationDays, props.subscriptionPlan.durationMonths)}
          </small>
        </p>
      </div>

      <div className="d-flex">
        <div style={{ minWidth: 20 }}>
          {
            props.isCalculatingPricing
              ? <FontAwesomeIcon icon="spinner" className="fa-pulse small text-gray-light" />
              : <FontAwesomeIcon icon="angle-double-right" className="text-gray-light" />
          }
        </div>

        <div>
          <span className="h4"><strong>{formatPrice(totalPrice)}</strong></span>

          {
            savingsComponent && savingsComponent.priceInCents !== 0 && (
              <>
                {' '}
                <small className="text-gray-light">
                  <s>{formatPrice(listPrice)}</s> with {savingsComponent.name}
                </small>
              </>
            )
          }

          <div style={{ minHeight: lsacComponent ? 48 : 24 }}>
            {
              !!lsacComponent?.priceInCents && (
                <div>
                  <small>
                    including {formatPrice(lsacComponent.priceInCents)} one-time LawHub Advantage fee
                    (nonrefundable
                    {' '}
                    <OverlayTrigger
                      overlay={
                        <Tooltip>
                          The LawHub Advantage fee goes directly to LSAC, is nonrefundable, and is not included in our 7-day money back guarantee.
                        </Tooltip>
                      }
                    >
                      <span>
                        <FontAwesomeIcon icon="question-circle" />
                      </span>
                    </OverlayTrigger>
                    )
                  </small>
                </div>
              )
            }
            {
              !props.isInstallments && !!taxComponent?.priceInCents && (
                <div>
                  <small>including {formatPrice(taxComponent.priceInCents)} sales tax</small>
                </div>
              )
            }
            {
              props.isInstallments && (
                <div>
                  <strong>Each Installment: {formatPrice(utils.calculateInstallmentsPrice(totalPrice))}</strong>
                  {
                    !!taxComponent?.priceInCents && (
                      <small> (including {formatPrice(utils.calculateInstallmentsPrice(taxComponent.priceInCents))} sales tax)</small>
                    )
                  }
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
